import React from 'react';
import { useParams } from 'react-router-dom';

import EmailMessagesList, { TColumns } from '@dashboard/components/EmailMessagesList';
import ListModelNavigation from '@dashboard/components/ListModelNavigation';
import { SimpleDateCell } from '@dashboard/components/table/cells/SimpleTextCell';
import { useContactsListHref } from '@dashboard/hooks/route/hrefs';
import { useCurrentPage } from '@dashboard/hooks/route/useCurrentPage';
import { getEmailMessageSourceLabel } from '@dashboard/models/EmailMessage';
import { Grid, Typography } from '@mui/material';

import { TemplateName } from '../Activity/columns';
import LastEventColumn from '../Activity/LastEventColumn';

import ContactShowHeader from './ContactShowHeader';
import { useContactEmailMessagesFilters } from './hooks';

const COLUMNS: TColumns = [
  { headerName: 'Event', renderCell: LastEventColumn, minWidth: 128, maxWidth: 128 },
  {
    headerName: 'Source',
    minWidth: 128,
    maxWidth: 128,
    renderCell: ({ row }) => <Typography noWrap>{getEmailMessageSourceLabel(row.source)}</Typography>,
  },
  {
    headerName: 'Timestamp',
    renderCell: ({ row }) => <SimpleDateCell value={row.createdAt} />,
    minWidth: 176,
    maxWidth: 192,
  },
  {
    headerName: 'Template',
    renderCell: TemplateName,
  },
  {
    headerName: 'From',
    renderCell: ({ row }) => <Typography noWrap>{row.message.from}</Typography>,
  },
  {
    headerName: 'ID',
    renderCell: ({ row }) => <Typography noWrap>{row.id}</Typography>,
    minWidth: 128,
    maxWidth: 200,
  },
];

export default function ContactsShow() {
  const page = useCurrentPage();
  const [filter, setFilter] = useContactEmailMessagesFilters();
  const id = useParams<{ id: string }>().id!;
  const getLinkHref = (id: string) => `../contacts/${id}`;
  const backLinkHref = useContactsListHref();

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} lg={1}>
        <ListModelNavigation currentModelId={id} backLinkHref={backLinkHref} getLinkHref={getLinkHref} />
      </Grid>
      <Grid item xs={12} lg={11}>
        <EmailMessagesList
          title={<ContactShowHeader />}
          page={page}
          columns={COLUMNS}
          filter={filter}
          setFilter={setFilter}
        />
      </Grid>
    </Grid>
  );
}
